function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Covid");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Covid",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M16,0 L16.0009361,3.04809625 C17.5790698,3.34459908 19.0394432,3.97494448 20.3059163,4.86299245 L22.4852814,2.6862915 L25.3137085,5.51471863 L23.1183027,7.71189228 C23.9817018,8.97772531 24.5901358,10.4313418 24.8696927,11.9988301 L28,12 L28,16 L24.8558159,16.0007013 C24.5668248,17.5578677 23.9529187,19.0009322 23.087077,20.2569158 L25.3137085,22.4852814 L22.4852814,25.3137085 L20.2608996,23.091679 C19.0048832,23.9631899 17.5604053,24.5821787 16.0009361,24.8751748 L16,28 L12,28 L11.9995873,24.8979117 C10.4228637,24.6203824 8.96079209,24.0102029 7.68842751,23.1424284 L5.51471863,25.3137085 L2.6862915,22.4852814 L4.84011379,20.3311701 C3.94703168,19.0579325 3.31444272,17.5886453 3.01973961,16.0007013 L0,16 L0,12 L3.0058629,11.9988301 C3.29083723,10.4009659 3.91755857,8.92142959 4.80773433,7.63851367 L2.6862915,5.51471863 L5.51471863,2.6862915 L7.6424975,4.81233631 C8.92555991,3.92782712 10.4038572,3.30623411 11.9995873,3.02535931 L12,0 L16,0 Z M18,15 C16.8954305,15 16,15.8954305 16,17 C16,18.1045695 16.8954305,19 18,19 C19.1045695,19 20,18.1045695 20,17 C20,15.8954305 19.1045695,15 18,15 Z M10,8 C8.8954305,8 8,8.8954305 8,10 C8,11.1045695 8.8954305,12 10,12 C11.1045695,12 12,11.1045695 12,10 C12,8.8954305 11.1045695,8 10,8 Z",
  id: "Combined-Shape",
  fill: "#3366CC",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#FFFFFF",
  opacity: 0,
  x: 0,
  y: 0,
  width: 28,
  height: 28
})));

var SvgCovid = function SvgCovid(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCovid, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/covid.56829c5b.svg";
export { ForwardRef as ReactComponent };